export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'all',
    name: '全部文章',
    description: '浏览所有娜娜轻量版相关文章',
    icon: 'ri-stack-line',
  },
  {
    slug: 'product-updates',
    name: '产品动态',
    description: '了解娜娜轻量版最新版本更新和产品资讯',
    icon: 'ri-rocket-line',
  },
  {
    slug: 'tutorials',
    name: '使用教程',
    description: '从入门到精通，掌握娜娜轻量版全部功能',
    icon: 'ri-book-open-line',
  },
  {
    slug: 'efficiency-tips',
    name: '效率技巧',
    description: '提升工作效率的实用方法论与操作技巧',
    icon: 'ri-lightbulb-flash-line',
  },
  {
    slug: 'industry-news',
    name: '行业资讯',
    description: '轻量应用行业动态与发展趋势解读',
    icon: 'ri-global-line',
  },
];